// Indian-locale currency formatting
// Default UI display: NO decimals (₹2,000) — applied across plans, dashboard, admin tables, etc.
// `inrFull()` keeps the .00 form — reserved for the Razorpay checkout page only.

function _toNumber(value) {
  if (value === null || value === undefined || value === "") return null;
  const n = typeof value === "number" ? value : Number(value);
  return Number.isFinite(n) ? n : null;
}

export function formatINR(value) {
  const n = _toNumber(value);
  if (n === null) return value === null || value === undefined || value === "" ? "—" : String(value);
  // Round to a whole rupee for display
  return Math.round(n).toLocaleString("en-IN", { maximumFractionDigits: 0 });
}

export function inr(value) {
  return `₹${formatINR(value)}`;
}

// Razorpay / checkout only — keeps two decimals
export function inrFull(value) {
  const n = _toNumber(value);
  if (n === null) return value === null || value === undefined || value === "" ? "—" : String(value);
  return `₹${n.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}
